import { render } from "./ArrowDownIcon.vue?vue&type=template&id=148bfb66"
const script = {}
script.render = render

export default script